<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Crm5fo/tc-custom/9781504084376.jpg?1705231657150" alt="This image is the cover for the book Nada the Lily"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Nada the Lily
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The son of a Zulu king teams up with a spectral wolf king to fight for honor and the woman he loves in this classic adventure tale by the author of <i>She.</i></b></p><p><i>Nada the Lily</i> tells the story of Umslopogaas, a fierce young Zulu warrior. He is the son of Chaka, the great Zulu king and general, and love of Nada the Lily, the most beautiful of the Zulu women. </p> When Chaka orders Umslopogaas’s death, the young man flees for his life, only to be carried away by a lion. He is saved by Galazi, king of an army of ghost-wolves. Together, they fight for glory and honor, armed with the fabled weapons, the axe Groan-maker and a club named Watcher of the Fords. But even with all the power they yield together, they may not be ready when Chaka sends an army out to slay them . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        H. Rider Haggard
      </h2>
      
      <p class="authorDescription body article">H. Rider Haggard (1856&ndash;1925) was an English adventure novelist. Haggard studied law, but rather than pursuing a legal career took a secretarial position in what is now South Africa. His time there provided the inspiration for some of his most popular novels, including <I>She</I> (1887), an early classic of the lost world fantasy genre and one of the bestselling books of all time.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7e8a22c0